import React, { useState } from 'react';

import PageLayout from 'components/layouts/PageLayout';
import Button from 'components/input/NewButton';
import styled from 'styled-components';
// import Item from './Item';
import { listings } from 'types/dummy';
import Text from 'components/commons/Text';
import { useNavigate } from 'react-router-dom';
import { Row } from 'saladsoft-primitive';

const SettingsPage = () => {
  const [items, setItems] = useState(Array.from({ length: 6 }, (_, i) => (i + 1).toString()));
  const navigate = useNavigate();
  const PageTitle = () => {
    return (
      <Row gap="10px">
        <Text type="H2">전체 시설목록</Text>
        <Text type="H4">{listings?.length}개의 시설이 등록되어 있습니다.</Text>
      </Row>
    );
  };
  return (
    <PageLayout title={<PageTitle />} actionButton={<Button>시설추가</Button>}>
      <Container>
        {listings?.map((listing, index) => (
          <ItemContainer
            key={listing.id}
            onClick={() => {
              navigate(`/admin/listings/${listing.id}/photos`);
            }}
          >
            <ItemLayout>
              <img
                src={`${listing.image}`}
                alt={`Image ${listing.id}`}
                style={{ width: '100%', height: '100%', maxHeight: 230, objectFit: 'cover' }}
              />
            </ItemLayout>
            <div style={{ padding: 10 }}>
              <Text type="H3">하녹운</Text>
              <h2>익선동 가까이에 위치한 모던한 공간 하녹운</h2>
              <Text type="H5" buttonRole="DESCRIPTION">
                Jongno-gu, Seoul
              </Text>
            </div>
          </ItemContainer>
        ))}
      </Container>
    </PageLayout>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  > div {
    flex: 1 1 350px; // flex-basis를 350px로 설정
    min-width: 0;
    max-width: 400px;
    width: calc((100% - 40px) / 3); // 3개 아이템일 때의 최대 너비

    @media (max-width: 1200px) {
      width: calc((100% - 20px) / 2); // 2개 아이템일 때의 최대 너비
    }

    @media (max-width: 768px) {
      width: 100%; // 1개 아이템일 때의 너비
    }
  }
`;

const ItemContainer = styled.div`
  flex: 1 1 350px;
  min-width: 0;
  max-width: 400px;
  width: calc((100% - 40px) / 3);
  transition: transform 0.1s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 1200px) {
    width: calc((100% - 20px) / 2);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ItemLayout = styled.div`
  border-radius: 10px;
  overflow: hidden;
`;

export default SettingsPage;
